import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import {
  FORMAT_TEXT_COMMAND,
  KEY_DOWN_COMMAND,
  COMMAND_PRIORITY_HIGH,
} from 'lexical';

export function KeyboardShortcutsPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_DOWN_COMMAND,
      (event: KeyboardEvent) => {
        const { metaKey, ctrlKey, key } = event;

        // Check for cmd/ctrl key combinations
        if (metaKey || ctrlKey) {
          switch (key.toLowerCase()) {
            case 'b':
              event.preventDefault();
              event.stopPropagation();
              editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
              return true;

            case 'i':
              event.preventDefault();
              event.stopPropagation();
              editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
              return true;

            case 'u':
              event.preventDefault();
              event.stopPropagation();
              editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
              return true;

            // Add more shortcuts as needed
            default:
              break;
          }
        }

        return false;
      },
      COMMAND_PRIORITY_HIGH,
    );
  }, [editor]);

  return null;
}
